export default "__VITE_ASSET__Md0bzfP4__";